module.exports = __webpack_public_path__ + "static/logo-2740b191a74245dc48ee30c68d5192aa.svg";